import LoadingIndicatorFull from '../LoadingIndicatorFull';
import styles from './style.m.less';

type Props = {
    isPending: boolean;
};

export default function GlobalLoadingIndicator({ isPending }: Props) {
    return (
        <div className={isPending ? styles.wrapperActive : styles.wrapper}>
            <LoadingIndicatorFull />
        </div>
    );
}
